import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IFrequentTravellerCard, IIdentityInfo, ISfpd } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { Yii } from "libraries/interfaces/Yii";
import { IWenji } from "libraries/interfaces/IWenji";
import { TravellerDataTranslationService } from "libraries/service/traveller-data-translation/traveller-data-translation.service";
import { ILabels } from "libraries/interfaces/ILabels";
import { TravellerXGender } from "libraries/service/resources/booking/interfaces/get-bookings.enum";

import { faAngleDown, IconDefinition } from "@fortawesome/free-solid-svg-icons";

declare const wenji: IWenji;

@Component({
    selector: 'identity-info',
    template: `
        <div>{{wording[type]}}</div>
        <div *ngFor="let identity of identities; let i = index">
            <strong (click)="toggle(i)">
                <ng-container *ngIf="identity.number || type === 'secureFlightPassengerData'; else noNumber">
                    <span *ngIf="identity.number"
                          class="e2e-identity-document-number">{{identity.number}}</span>
                    <span *ngIf="type === 'secureFlightPassengerData'"
                          class="e2e-sfpd-birthdate">{{identity.holder.birthDate | dateMoment : dateFormat}}</span>
                </ng-container>
                <ng-template #noNumber>{{wording.noNumber}}</ng-template>
                <fa-icon [icon]="iconAngleDown" *ngIf="type !== 'frequentTravellerCard'"></fa-icon>
            </strong>
            <div *ngIf="show[i]" class="identity-content">
                <div *ngIf="identity.holder">
                    {{wording.holdBy}} {{names[i]}}
                </div>
                <div *ngIf="identity.holder?.citizenShip?.country?.code">
                    {{wording.nationality}} {{identity.holder.citizenShip.country.code}}
                </div>
                <div *ngIf="identity.placeOfIssue?.country?.code">
                    {{wording.deliveryCountry}} {{identity.placeOfIssue.country.code}}
                </div>
                <div *ngIf="identity.validity?.end">
                    {{wording.validityEnd}} {{identity.validity.end | dateMoment : dateFormat}}
                </div>
                <div *ngIf="identity.holder?.birthDate">
                    {{wording.birthDate}} {{identity.holder.birthDate | dateMoment : dateFormat}}
                </div>
                <div *ngIf="identity.holder?.xTitle">
                    {{wording.title}} {{identity.holder?.xTitle}}
                </div>
                <div *ngIf="identity.holder?.xGender">
                    {{wording.gender}}
                    <ng-container *ngIf="identity.holder.xGender === male">{{wording.male}}</ng-container>
                    <ng-container *ngIf="identity.holder.xGender === female">{{wording.female}}</ng-container>
                </div>
            </div>
        </div>
    `,
    styles: [`
        strong {
            cursor: pointer
        }

        .identity-content {
            padding-left: .75rem;
        }
    `]
})

export class IdentityInfoComponent implements OnChanges {

    @Input()
    public identities: IIdentityInfo[] | IFrequentTravellerCard[] | ISfpd[];

    @Input()
    public type: 'identityCard'|'passport'|'visa'|'frequentTravellerCard'|'secureFlightPassengerData';

    public readonly male: TravellerXGender = TravellerXGender.male;
    public readonly female: TravellerXGender = TravellerXGender.female;

    public names: string [] = [];

    public title: string = null;

    public readonly wording: ILabels = {
        identityCard: Yii.t('wui-shared-js', "Carte d'identité :"),
        passport: Yii.t('wui-shared-js', "Passeport :"),
        visa: Yii.t('wui-shared-js', "Visa :"),
        frequentTravellerCard: Yii.t('wui-shared-js', "Carte de fidélité :"),
        validityEnd: Yii.t('wui-shared-js', "Date d'expiration :"),
        nationality: Yii.t('wui-shared-js', "Nationalité :"),
        deliveryCountry: Yii.t('wui-shared-js', "Pays de délivrance :"),
        holdBy: Yii.t('wui-shared-js', "Au nom de :"),
        noNumber: Yii.t('wui-shared-js', "Numéro inconnu"),
        title: Yii.t('wui-shared-js', "Civilité :"),
        gender: Yii.t('wui-shared-js', "Sexe :"),
        birthDate: Yii.t('wui-shared-js', "Date de naissance :"),
        secureFlightPassengerData: Yii.t('wui-shared-js', "SFPD :"),
        male: Yii.t('wui-shared-js', "Homme"),
        female: Yii.t('wui-shared-js', "Femme"),
    };

    public show: boolean[] = [];
    public readonly dateFormat: string = JSON.parse(wenji.ui.dateFormat).momentShort;

    public iconAngleDown: IconDefinition = faAngleDown;

    constructor(private travellerDataTranslationService: TravellerDataTranslationService) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (this.identities && changes.identities && changes.identities.currentValue) {
            this.names = changes.identities.currentValue
                .map((identity: IIdentityInfo) => {
                    if (identity.holder) {
                        return this.travellerDataTranslationService.getTravellerIdentity(identity.holder);
                    }
                    return null;
                });
        }
    }

    public toggle(index: number): void {
        this.show[index] = !this.show[index];
    }

}

